export default __webpack_public_path__ + "static/media/lunch3.4258c40a.png";